/**
 * Container for ManageWorkers
 */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Alert, Grid, Typography, CircularProgress, Button, Box, TextField, Autocomplete, InputAdornment, FormControl, InputLabel, Select, MenuItem, } from "@mui/material"
import PropTypes from "prop-types";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import { Add, Delete, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { styled } from "@mui/system";
import Seperator from "components/Seperator";
import { ADD_WORKER } from "navigation/CONSTANTS";
import { OTHER_TEAM, TEMP, DELETED, SPACE, DOT } from "config/CONSTANTS";
import {
  editContingentWorker,
  getWorkersByMgr,
  reassignReportees,
} from "services";
import _ from "lodash";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ConfirmDialog from "components/ConfirmDialog";
import ConfirmActionDialog from "components/ConfirmActionDialog";
import Confirmation from "components/Confirmation";
import { properCase, getFullName } from "utils";
import { useDispatch } from "react-redux";
import { getManagerEmails, saveFilterList } from "redux/actions/appActions";
import { EDIT } from "pages/AddWorker/config";
import NoData from "utils/NoData";

const ManageWorkers = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState("");
  const { allWorkers, selectedTeam, approveForManager, selectedWorkers, imtRole, isLoading: workersLoading } = props;
  const [workers, setWorkers] = useState({});
  const [statusFilter, setStatusFilter] = useState("Active");
  const [columnFilter, setColumnFilter] = useState([
    {id: "isActiveWorker", value: 'true'}
  ])
  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.appConfig);
  const reportTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: 10,
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#1B75BC",
        },
      },
      MuiTypography: {
        body2: {
          color: "#1B75BC",
        },
      },
      MuiInputLabel: {
        root: {
          "&$focused": {
            color: "#1B75BC",
          },
        },
      },
      MUIDataTableToolbar: {
        iconActive: {
          color: "#1B75BC",
        },
        icon: {
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiChip: {
        label: {
          color: "#1B75BC",
        },
      },
      MuiChip: {
        deleteIcon: {
          color: "#1B75BC",
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          "&$checked": {
            color: "#1B75BC",
          },
        },
      },
      MuiInput: {
        underline: {
          "&&:after": {
            borderBottom: "2px solid #1B75BC",
          },
        },
      },
    },
  });
  const { user } = useSelector((state) => state.user.auth);
  const { manageWorkersFiltersData } = useSelector((state) => state.appConfig);

  const [confirmationBox, setConfirmationBox] = useState({
    isOpen: false,
    title: t("pgReview.deleteWorkersDialog.delSuccessTitle"),
  });
  const [confirmDialogDel, setConfirmDialogDel] = useState({
    isOpen: false,
    title: "pgReview.deleteWorkersDialog.title",
    subTitle: "pgReview.deleteWorkersDialog.subTitle",
    alertMsg: "other.1",
  });
  const [confirmDialogManagerDel, setConfirmDialogManagerDel] = useState({
    isOpen: false,
    title: "other.managerDeleteTitle",
    subTitle: "other.managerDeleteSubTitle",
    primaryAction: "Reassign",
    secondaryAction: "Cancel",
  });
  const [managerOptions, setManagerOptions] = useState([]);

  useEffect(() => {
    if (appConfig !== null) {
      if (appConfig.managerEmails == null) {
        dispatch(getManagerEmails());
      }
    }
  }, []);
  useEffect(() => {
    if (appConfig && appConfig.managerEmails !== null) {
      let managerDetails = appConfig.managerEmails;
      setManagerOptions(managerDetails);
    }
  }, [user, appConfig.managerEmails]);

  const handleManagerChange = (event, newValue) => {
    if (newValue && newValue !== null && typeof newValue === "object") {
      setConfirmDialogManagerDel({
        ...confirmDialogManagerDel,
        disablePrimary: false,
        onConfirm: () => {
          reassignWorkers(confirmDialogManagerDel.deletedWorker, newValue);
        },
      });
    } else {
      setConfirmDialogManagerDel({
        ...confirmDialogManagerDel,
        disablePrimary: true,
      });
    }
  };

  const reassignWorkers = (worker, manager) => {
    setConfirmDialogManagerDel({
      ...confirmDialogManagerDel,
      disablePrimary: true,
      isLoading: true,
    });
    console.log(">>> Selected Manager to reassign", manager);
    console.log(">>> DeletedWorker", worker);
    manager = {
      ...manager,
      actionTS: new Date().toISOString(),
      actionBy: user.workerId,
      actionType: EDIT,
    };
    reassignReportees(worker.workerId, manager)
      .then((result) => {
        setConfirmDialogManagerDel({
          ...confirmDialogManagerDel,
          isOpen: false,
          isLoading: false,
        });
        if (result) {
          deleteWorker(
            worker,
            t("other.delManagerSuccessMsg") +
            SPACE +
            getFullName(manager.managerFirstName, manager.managerLastName) +
            DOT
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteWorkerRecord = (cwk) => {
    setConfirmDialogDel({ ...confirmDialogDel, isOpen: false });
    if (cwk) {
      const managerDetails = managerOptions.filter(
        (record) =>
          record.managerCountry == cwk.country &&
          record.managerId != cwk.workerId
      );
      setManagerOptions(managerDetails);
    }
    if (cwk.isApprover) {
      getWorkersByMgr(cwk.workerId)
        .then((data) => {
          if (data && data.workers && data.workers.length > 0) {
            setConfirmDialogManagerDel({
              ...confirmDialogManagerDel,
              isOpen: true,
              disablePrimary: cwk.isApprover,
              childrenVisible: cwk.isApprover,
              deletedWorker: cwk,
            });
          } else {
            deleteWorker(cwk, t("pgReview.deleteWorkersDialog.delSuccessMsg"));
          }
        })
        .catch((err) => {
          console.error("Error in deleteWorkerRecord, Err===", err);
        });
    } else {
      deleteWorker(cwk, t("pgReview.deleteWorkersDialog.delSuccessMsg"));
    }
  };

  const deleteWorker = (cwk, deleteMessage) => {
    delete cwk.canDelete;
    cwk = {
      ...cwk,
      isDeleted: true,
      isActiveWorker: false,
      actionTS: new Date().toISOString(),
      actionBy: user.workerId,
      actionType: DELETED,
    };
    console.log("Delete worker=====", cwk);
    editContingentWorker(cwk)
      .then((result) => {
        if (result) {
          setConfirmationBox({
            ...confirmationBox,
            subTitle: deleteMessage,
            isOpen: true,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteDone = () => {
    props.reloadList && props.reloadList();
    setConfirmationBox({ ...confirmationBox, isOpen: false });
  };

  useEffect(() => {
    setIsLoading(true);
    setLoadingError("");

    let workers = [];
    if (selectedTeam === OTHER_TEAM && approveForManager) {
      if ((imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor") || (!imtRole && user && user.isApprover)) {
        workers = _.cloneDeep(selectedWorkers);
      } else {
        workers = _.cloneDeep(allWorkers.allOtherTeam);
     }
    } else {
      workers = _.cloneDeep(allWorkers.all);
      
    }

    const formattedWorkers = workers ? _.cloneDeep(workers).map((worker) =>{
      let canDelete = false;
      if(worker?.workerType === TEMP){
        canDelete = true;
      }
      return {
        ...worker,
        canDelete
      };
    }) : [];
    
    setWorkers(formattedWorkers);

    console.log("formattedWorker", workers)
    if (workers && workers.length > 0) {
      let result = workers;
      if (result && result.length == 0) {
        setLoadingError("pgReview.noContingentWorkers");
      }
    } else {
      if (workers) {
        //Empty workers list
        setLoadingError("pgReview.noContingentWorkers");
      } else {
        //No workers object
        setLoadingError("pgReview.noWorkerForManager");
      }
    }
    setIsLoading(false);
    
  }, [selectedTeam, approveForManager, selectedWorkers, allWorkers]);

  const handleStatusFilter = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    setColumnFilter([
      {id: "isActiveWorker", value: value === "Active" ? "true" : "false" }
    ])
  }

  
  const columns = [
      {
          accessorKey: "name",
          header: properCase(t("pgReview.tableHeads.name")),
          display: true,
          filter: true,
          enableColumnDragging: false,
          filterList : manageWorkersFiltersData[0].length
              ? manageWorkersFiltersData[0]
              : null,
              Cell: ({renderedCellValue, row}) => {
                 let dataIndex = row.index;
                 let data = workers[dataIndex];
                 const link = (
                    <Link
                      style={{ textDecoration: "none", color: "#1b75bc" }}
                      to={{
                        pathname: ADD_WORKER,
                        state: {
                          empId: data.workerId,
                          worker: data,
                        },
                      }}
                    >
                      
                      {renderedCellValue}
                    </Link>
                  );
                  return link;
              },

      },
     {
      accessorKey: "workerId",
      header: properCase(t("pgReview.tableHeads.employeeId")),
      
        display: true,
        filter: true,
        size: 50,
        filterList: manageWorkersFiltersData[1].length
          ? manageWorkersFiltersData[1]
          : null,
      
    },
     {
		accessorKey: "workerType",
		header: properCase(t("pgReview.tableHeads.workerType")),
        display: true,
        filter: true,
        size: 50,
        enableColumnDragging: false,
        filterFn:(row, id, filterValue) => 
          row.getValue(id) === filterValue,
        filterSelectOptions:[
          {text: 'Temporary', value: 'temp'},
          {text: 'Employee', value: 'employee'},
        ],
        filterVariant: 'select',
        filterList: manageWorkersFiltersData[2].length
          ? manageWorkersFiltersData[2]
          : null,
        Cell:({renderedCellValue, cell, row}) =>
          cell.getValue() === 'temp' ? 'Temporary' : 'Employee'
      },
      {
      accessorKey: "jobType",
      header: properCase(t("other.jobType")),
      
        display: true,
        filter: true,
        filterList: manageWorkersFiltersData[2].length
          ? manageWorkersFiltersData[2]
          : null
     },
   {
		accessorKey: "email",
		header: properCase(t("pgReview.tableHeads.email")),
        display: true,
        filter: false,
         filterList: manageWorkersFiltersData[3].length
          ? manageWorkersFiltersData[3]
          : null,
    },
	{
      accessorKey: "isActiveWorker",
      header: properCase(t("pgReview.tableHeads.isActive")),    
        display: true,
        filter: true,
        size: 50,
        enableColumnDragging: false,
        filterFn:(row, id, filterValue) => {
          const value = row.getValue(id);
          const selectedOption = filterValue === 'true';
          return selectedOption === Boolean(value);
        },
        filterSelectOptions:[
          {text: 'Yes', value: "true"},
          {text: 'No', value: "false"},
        ],
        filterVariant: 'select',
        filterList: manageWorkersFiltersData[4].length
          ? manageWorkersFiltersData[4]
          : null,
        Cell:({renderedCellValue, cell, row}) => cell.getValue() ? 'Yes' : 'No'
                          
        
    },
	{
      accessorKey: "isOnLeave",
      header: properCase(t("other.isOnLeave")),
        display: true,
        filter: true,
        size: 50,
        enableColumnDragging: false,
        filterFn:(row, id, filterValue) => {
          const value = row.getValue(id);
          const selectedOption = filterValue === 'true';
          return selectedOption === Boolean(value);
        },
        filterSelectOptions:[
          {text: 'Yes', value: "true"},
          {text: 'No', value: "false"},
        ],
        filterVariant: 'select',
        filterList: manageWorkersFiltersData[5].length
          ? manageWorkersFiltersData[5]
          : null,
          Cell:({renderedCellValue, cell, row}) => cell.getValue() ? 'Yes' : 'No'               
       },
	{
      accessorKey: "isApprover",
      header: properCase(t("other.isApprover")),
      display: true,
      filter: true,
      size: 50,
      enableColumnDragging: false,
      filterFn:(row, id, filterValue) => {
        const value = row.getValue(id);
        const selectedOption = filterValue === 'true';
        return selectedOption === Boolean(value);
      },
      filterSelectOptions:[
        {text: 'Yes', value: "true"},
        {text: 'No', value: "false"},
      ],
      filterVariant: 'select',
      filterList: manageWorkersFiltersData[6].length
        ? manageWorkersFiltersData[6]
        : null,
      Cell:({renderedCellValue, cell, row}) =>
            cell.getValue() === true ? 'Yes' : 'No'
    },
    ];
  //const data = workers;
  const table = useMaterialReactTable({
    columns,
    data: workers,
    enableRowActions: true,
    enableSelectAll: true,
    enablePagination: true,
    enableGrouping: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: workersLoading,
      showProgressBars: workersLoading,
      columnFilters: columnFilter
    },
    onColumnFiltersChange: setColumnFilter,
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition:'none'
        }
      },
      variant: 'determinate'
    },
    muiSkeletonProps:{
      animation:'wave',
      height: 20
    },
    enableStickyFooter: true,
    // onRowSelectionChange: onRowSelectionChange,
    muiPaginationProps:{
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true
    },
    initialState: {
      density: "compact",
      columnPinning: {
        right: ['mrt-row-actions'],
      },
      pagination:{
        pageSize: 50
      }
    },
    muiTableContainerProps: {
      sx: {
        minHeight: `calc(100vh - 400px)`,
        maxHeight: `calc(100vh - 220px)`
      },
    },

    
    renderRowActions: ({ row, table }) => (
   <>
          {row?.original?.canDelete ? (
            <Link to="#" title={t("pgReview.tableStaticText.btnDelete")}>
              <Delete
                color="error"
                alignItems = "center"
                onClick={() =>
                  setConfirmDialogDel({
                    title: "pgReview.deleteWorkersDialog.title",
                    subTitle:
                      t("pgReview.deleteWorkersDialog.subTitle") +
                      row.original.name +
                      " ?",
                    alertMsg: t("other.1"),
                    isOpen: true,
                    onConfirm: () => {
                      deleteWorkerRecord(row.original);
                    },
                  })
                }
              />
            </Link>
          ) : null}
        </>
      
    ),
    renderTopToolbarCustomActions: () => {
      return (
        <Box sx={{margin: "10px"}}>
        <Typography variant='h6' sx={{color: "#58595B"}}>
         {properCase(t("pgHome.btnManageWorkers"))}
        </Typography>
      </Box>
      )
    }
  });
  return (
        <>
          <MuiThemeProvider theme={reportTheme}>
        
          <ManageWorkersHeader
              approveForManager={approveForManager}
              selectedTeam={selectedTeam}
              statusFilter={statusFilter}
              handleStatusFilter={handleStatusFilter}
              />
                <MaterialReactTable table={table} />
         </MuiThemeProvider>

          <ConfirmDialog
            confirmDialog={confirmDialogDel}
            setConfirmDialog={setConfirmDialogDel}
          />
          <ConfirmActionDialog
            confirmDialog={confirmDialogManagerDel}
            setConfirmDialog={setConfirmDialogManagerDel}
          >
            <Autocomplete
              options={managerOptions}
              freeSolo
              getOptionLabel={(option) =>
                option && option.managerFirstName
                  ? option.managerFirstName + " " + option.managerLastName
                  : option
              }
              onChange={(event, worker) =>
                handleManagerChange(event, worker, true)
              }
              id="employeeSearch"
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={t("other.searchManager")}
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </ConfirmActionDialog>
          <Confirmation
            confirmationMsg={confirmationBox.isOpen}
            closeModalConfirmationMsg={deleteDone}
            confirmationMsgText={confirmationBox.subTitle}
            confirmationTitleText={confirmationBox.title}
          />
        </>
  );
};

const ManageWorkersHeader = (props) => {
  const StyledButton = styled(Button)({
    color:"#1b75bc",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "25px",
    borderRadius: "5px",
    ':hover':{
      backgroundColor:"#1b75bc",
      color:"#FFFFFF",
    }
  });
  const { approveForManager, selectedTeam, statusFilter, handleStatusFilter } = props;
  const imtRole = useSelector((state) => state.user.imtRole.userRole);
  const { t } = useTranslation();
  const history = useHistory();
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
      if(imtRole?.role !== "Support"){
        setReadOnly(false)
      }
  },[imtRole]);

  return (
    <>
      <Grid container display="flex" justifyContent="space-between">
        <Grid item>
          <FormControl>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={statusFilter}
              onChange={handleStatusFilter}
              sx={{
                minWidth: 230,
                maxHeight: 50,
                backgroundColor: "white"
              }}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={() =>
              history.push(
                ADD_WORKER,
                selectedTeam === OTHER_TEAM && {
                  approveForManager: approveForManager,
                }
              )
            }
            startIcon={<Add />}
            disabled={readOnly}
          >
            {t("pgReview.btnAddWorker")}
          </StyledButton>
        </Grid>
      </Grid>
      <Seperator />
    </>
  );
};

ManageWorkers.propTypes = {
  allWorkers: PropTypes.object.isRequired,
  handleEditWorker: PropTypes.func.isRequired,
  selectedTeam: PropTypes.func.isRequired,
  approveForManager: PropTypes.object.isRequired,
};

ManageWorkersHeader.propTypes = {
  approveForManager: PropTypes.object.isRequired,
  selectedTeam: PropTypes.func.isRequired,
};
export default ManageWorkers;
